/**
 * **Brisas Hotels**
 *
 * @exports partnership_362
 * @category partnerships
 */
function factory({ window, document, thn }) {
    const partnership = {};
    /**
       * @memberOf module:partnership_362
       */
    partnership.boot = function boot() {
        const container = document.querySelector('#step1');
        if (container) {
            const refreshPartner = thn.debounce(thn.siteCheck, 150);
            thn.observeDom(container, refreshPartner, {
                childList: true,
                subtree: true,
                attributes: true,
            });
            partnership.shutdown = () => {
                refreshPartner.cancel();
                thn.stopObserveDom(container, refreshPartner);
            };
        }
        if (!window.dataLayer) {
            return;
        }
        partnership.shutdown = thn.generateCallbackQueue();
        const refreshPartnership = thn.debounce(thn.siteCheck, 300);
        let dataLayerHelper = new thn.DataLayerHelper(window.dataLayer, function (model, message) {
            if (message.event === 'yd_hotel_selected') {
                refreshPartnership();
            }
        }, true);
        partnership.shutdown = function () {
            dataLayerHelper.unlisten();
            dataLayerHelper = null;
        };
    };
    /**
       * @memberOf module:partnership_362
       */
    partnership.getId = function getId() {
        return '362';
    };
    /**
       * @memberOf module:partnership_362
       */
    partnership.check = function check() {
        const validDomainsRegExp = /reserve\.brisas|lasbrisashotels|galeriaplazahotels/;
        return validDomainsRegExp.test(window.location.hostname);
    };
    /**
       * @memberOf module:partnership_362
       */
    partnership.getHotelId = function getHotelId() {
        let hotelId;
        if (window.location.hostname.includes('reserve.brisas')) {
            hotelId = thn.dataLayerHelper.get('hotel_selected') ?? thn.dataLayerHelper.get('hotel_id');
        }
        else {
            // In this case we are in the homepages and we must install one script or another depending on the hotel and the location of the visit.
            const hotelName = document.body.getAttribute('data-hotel');
            hotelId = hotelName && (document.querySelector('a[href*="reserve.brisas.com.mx"]') || document.querySelector('[data-location]')?.dataset?.location === 'DOMESTIC') ? `${hotelName}_mx` : hotelName;
        }
        const result = {
            partnership_hotel_id: hotelId || '16C9D54CA42B943BD5606FE569833174',
        };
        return result;
    };
    return partnership;
}

export { factory };
